import "./buttons.scss";

import { ReactComponent as CloseIcon } from "../icons/closeWhite.svg";

export const CloseButton = (props: {
  onClick: () => void;
  id?: string;
}): JSX.Element => {
  return (
    <button
      id={props.id}
      className="rg-button more"
      title="Close"
      onClick={props.onClick}
    >
      <CloseIcon />
    </button>
  );
};
